/* 🤖 this file was generated by script */
export const wiconShuffle02 = {
  name: 'shuffle_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 16v5m0 0h-5m5 0l-6-6M3 3l6 6m7-6h5m0 0v5m0-5L3 21"/></svg>`,
};
